module.exports = __webpack_public_path__ + "static/media/YF87_3.ee695d96.jpg";